import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { PerformanceMetrics } from '../types/dashboard';
import { formatNumber } from '../utils/formatters';

interface SignalsReceivedCardProps {
  metrics: PerformanceMetrics;
}

const SignalsReceivedCard: React.FC<SignalsReceivedCardProps> = ({ metrics }) => {
  const theme = useTheme();
  const totals = metrics.totalAlerts;

  const cells: Array<{ label: string; value: number }> = [
    { label: 'Today', value: totals.today },
    { label: 'This week', value: totals.thisWeek },
    { label: 'This month', value: totals.thisMonth },
  ];

  return (
    <Card sx={{ mb: 2.5 }}>
      <CardContent>
        <Typography variant="h6" sx={{ fontFamily: theme.typography.h5.fontFamily, fontWeight: 500 }}>
          Signals received
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Incoming indicator signals across all your alerts. Each one may or may not trigger a trade,
          depending on alignment.
        </Typography>
        <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 1.5 }}>
          {cells.map((cell) => (
            <Box
              key={cell.label}
              sx={{
                textAlign: 'center',
                py: 1.5,
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: alpha(theme.palette.text.primary, 0.02),
              }}
            >
              <Typography
                variant="h4"
                sx={{ fontFamily: theme.typography.h4.fontFamily, lineHeight: 1 }}
              >
                {formatNumber(cell.value)}
              </Typography>
              <Typography variant="overline" sx={{ fontSize: 10, color: 'text.secondary' }}>
                {cell.label}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default SignalsReceivedCard;
